module.exports = __webpack_public_path__ + "static/media/dm-serif-display-v5-latin-ext_latin-regular.5c8aeb02.woff";